/* eslint-disable */

import React from "react";

let getCopyrightText = `© ${new Date().getFullYear()} | ALL RIGHTS RESERVED`;

function Footer() {
  return (
    <footer className="footer container-fluid">
      <div className="container-footer">
        <div className="heading">SOCIAL MEDIA PRESENCE</div>
        <ul className="unordered list-inline">
          <li>
            <a
              className="link"
              target="_blank"
              href="https://github.com/gautam-balamurali"
              rel="noopener noreferrer"
            >
              GITHUB
            </a>
          </li>
          <li>
            <a
              className="link"
              target="_blank"
              href="https://www.linkedin.com/in/gautam-balamurali"
              rel="noopener noreferrer"
            >
              LINKEDIN
            </a>
          </li>
          <li>
            <a
              className="link"
              target="_blank"
              href="https://twitter.com/codewithash"
              rel="noopener noreferrer"
            >
              TWITTER
            </a>
          </li>
        </ul>
        <div id="copyrt-txt">{getCopyrightText}</div>
      </div>
    </footer>
  );
}

export default Footer;
